(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squad-home-nav-featured"] && !Shopify.designMode) return;
  try {
    
  const squadHomeBlock = document.getElementById('squad-home-nav-featured');
  const primaryNavigation = squadHomeBlock?.querySelector('#squad-primary-navigation');
  const secondaryNavigation = squadHomeBlock?.querySelector('#squad-secondary-navigation');
  const featuredHeadline = document.getElementById('squad-featured-headline');
  const gradedHeadline = document.getElementById('squad-graded-headline');
  const sealedHeadline = document.getElementById('squad-sealed-headline');
  const faqHeadline = document.getElementById('squad-faq-headline');

  if (squadHomeBlock) {
    const placeHeadline = (headline, targetSelector) => {
      const target = document.querySelector(targetSelector);

      if (!headline || !target) return;

      const firstPageFlyRow = target.querySelector(':scope > [data-pf-type="Row"]');

      if (headline.parentElement !== target || headline.nextElementSibling !== firstPageFlyRow) {
        target.insertBefore(headline, firstPageFlyRow);
      }

      headline.hidden = false;
    };

    const placeAfterRows = (element, targetSelector) => {
      const target = document.querySelector(targetSelector);

      if (!element || !target) return;

      const pageFlyRows = [...target.querySelectorAll(':scope > [data-pf-type="Row"]')].filter((row) => row !== element);
      const lastPageFlyRow = pageFlyRows.at(-1);

      if (!lastPageFlyRow) return;

      if (element.parentElement !== target || lastPageFlyRow.nextElementSibling !== element) {
        target.insertBefore(element, lastPageFlyRow.nextElementSibling);
      }

      element.hidden = false;
      element.removeAttribute('aria-hidden');
    };

    const placeSquadHeadlines = () => {
      const oldNavigation = document.querySelector('[data-section-id="pf-fc2b"] > div > [data-pf-type="Row"]:first-child');
      const secondaryNavigationSource = document.querySelector('[data-section-id="pf-91af"]');

      if (oldNavigation) {
        oldNavigation.hidden = true;
        oldNavigation.setAttribute('aria-hidden', 'true');
      }

      if (secondaryNavigationSource) {
        secondaryNavigationSource.hidden = true;
        secondaryNavigationSource.setAttribute('aria-hidden', 'true');
      }

      placeHeadline(featuredHeadline, '[data-section-id="pf-9884"] > div');
      placeAfterRows(primaryNavigation, '[data-section-id="pf-9884"] > div');
      placeHeadline(gradedHeadline, '[data-section-id="pf-5199"] > div');
      placeAfterRows(secondaryNavigation, '[data-section-id="pf-5199"] > div');
      placeHeadline(sealedHeadline, '[data-section-id="pf-5fee"] > div');
      placeHeadline(faqHeadline, '[data-section-id="pf-06a5"] > div');
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', placeSquadHeadlines, { once: true });
    } else {
      placeSquadHeadlines();
    }

    let placementAttempts = 0;
    const placementTimer = window.setInterval(() => {
      placeSquadHeadlines();
      placementAttempts += 1;

      if (placementAttempts >= 40) {
        window.clearInterval(placementTimer);
      }
    }, 250);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-preorder-navigation"]) return;
  try {
    
  if (!customElements.get('ss-preorder-navigation')) {
    customElements.define('ss-preorder-navigation', class extends HTMLElement {
      connectedCallback() {
        this.sourceLink = this.querySelector('a');
        this.header = document.getElementById('shopify-section-header');
        if (!this.sourceLink || !this.header) return;
        const seriesOrder = new Map([
          '460943130842', '460943098074', '460943065306', '460485263578', '460942967002', '460942901466',
          '460942868698', '460942835930', '460942770394', '460942704858', '460942672090', '460942639322',
          '460942508250', '460942475482', '460942278874', '460942180570', '460941918426', '460941885658',
          '460941852890', '460485198042', '460941787354', '460941721818', '460941656282', '460683837658',
          '460683804890', '460683739354', '460683444442', '460941295834', '460683378906', '460683346138',
          '460683247834', '460683182298', '460683116762', '460683018458', '460682920154', '460682854618',
          '460488212698', '460682723546', '460682625242', '460940050650', '460682526938', '460939821274',
          '460682363098', '460939788506', '460682330330', '460682297562', '460682166490', '460682035418',
          '460681904346', '460681838810', '460681806042', '460681773274', '460485329114', '460681609434',
          '460681511130', '460681412826', '460681314522', '460681216218', '460681085146', '460680954074',
          '460680855770', '460680724698', '460538413274', '460538118362', '460537757914', '460537692378',
          '460485230810', '460537659610', '460537561306', '460537528538', '460537331930', '460537266394',
          '460537233626', '460537200858', '460536971482', '460485034202', '460536774874', '460536742106',
          '460536709338', '460536676570', '460536414426', '460536185050', '460536086746', '460535955674',
          '460502139098', '460502040794', '460501844186', '460501778650', '460501745882', '460501713114',
          '460501614810', '460492275930', '460491555034', '460491489498', '460491456730', '460491423962',
          '460491391194', '460491358426', '460491325658', '460491161818', '460491292890', '460491096282',
          '460491063514', '460490932442', '460490899674', '460490768602', '460490735834', '460490670298',
          '460490637530', '460490571994', '460490473690', '460490408154', '460490342618', '460490375386',
          '460488835290', '460488769754', '460488671450', '460488638682', '460487721178', '460487655642',
          '460487590106', '460484739290', '460484706522'
        ].map((id, index) => [id, index]));
        this.frame = null;
        this.syncMenus = () => {
          this.frame = null;
          this.header.querySelectorAll('.buddha-menu-item > a[aria-label="PRE-ORDERS"]').forEach((trigger) => {
            const list = trigger.parentElement.querySelector(':scope > ul.mm-submenu');
            if (!list) return;
            const href = this.sourceLink.getAttribute('href');
            if (trigger.getAttribute('href') !== href) trigger.setAttribute('href', href);
            if (trigger.getAttribute('data-href') !== href) trigger.setAttribute('data-href', href);
            if (list.querySelector(':scope > .ss-preorder-all-item')) return;
            const item = document.createElement('li');
            item.className = 'ss-preorder-all-item';
            item.setAttribute('role', 'none');
            item.appendChild(this.sourceLink.cloneNode(true));
            list.prepend(item);
          });
          this.header.querySelectorAll('.buddha-menu-item > a[aria-label="POKEMON SERIES"]').forEach((trigger) => {
            const list = trigger.parentElement.querySelector(':scope > ul.mm-submenu');
            if (!list) return;
            const items = Array.from(list.children);
            const ordered = items.slice().sort((a, b) => {
              const aRank = seriesOrder.get(a.getAttribute('data-shopify-id')) ?? Number.MAX_SAFE_INTEGER;
              const bRank = seriesOrder.get(b.getAttribute('data-shopify-id')) ?? Number.MAX_SAFE_INTEGER;
              return aRank - bRank;
            });
            if (ordered.every((item, index) => item === items[index])) return;
            ordered.forEach((item) => list.appendChild(item));
          });
        };
        this.observer = new MutationObserver(() => {
          if (this.frame === null) this.frame = requestAnimationFrame(this.syncMenus);
        });
        this.observer.observe(this.header, { childList: true, subtree: true });
        this.syncMenus();
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.frame !== null) cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
